module.exports = __webpack_public_path__ + "media/images/app/chevron-right-04ace1aa9e94cb6f9d5fb5268a179925.svg";